import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  styled,
  CircularProgress,
  Box,
} from '@mui/material';
import ArrowIcon from '../assets/icons/arrow-icon';
import { TabPanel } from './TabPanel';
import Checkbox from '@mui/material/Checkbox';
import CheckboxIcon from '../assets/icons/checkbox-icon';
import UncheckedIcon from '../assets/icons/uncheckbox-icon';
import { useEffect, useState } from 'react';
import { ParsedCuota } from '../features/cuentacorriente/ctaCorrienteSlice';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

interface Props {
  value: number;
  cuotas: ParsedCuota[];
  selectedCuotas: ParsedCuota[];
  setSelectedCuotas: (cuotas: ParsedCuota[]) => void;
  total: number;
  setTotal: (n: number) => void;
  status: string;
  textVisible: boolean | null;
}

const AccordionDetailsCustom = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,

  [theme.breakpoints.up('sm')]: {
    padding: undefined,
  },
}));

const TableTitle = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '.85rem',
  color: theme.palette.grey[400],
}));

const TableBold = styled(Typography)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '.85rem',
  color: theme.palette.grey[500],
}));

const TableRegular = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '.85rem',
  color: theme.palette.grey[500],
}));

export default function CtaCorriente(props: Props) {
  const {
    value,
    cuotas,
    selectedCuotas,
    setSelectedCuotas,
    total,
    setTotal,
    status,
    textVisible
  } = props;

  const getTotales = (monto: string, intereses: string, multa: string) => {
    return (Number(monto) + Number(intereses) + Number(multa)).toFixed(2);
  };

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalFine, setTotalFine] = useState(0);

  useEffect(() => {
    // Calculo de totales, si no hay cuotas seleccionadas... Calcula el total de todas las cuotas
    if (selectedCuotas && selectedCuotas.length === 0) {
      const firstTotal = cuotas
        .map(cuota => Number(cuota.monto_original))
        .reduce((acc, val) => acc + val, 0);
      setTotalAmount(firstTotal);

      const secondTotal = cuotas
        .map(cuota => Number(cuota.intereses))
        .reduce((acc, val) => acc + val, 0);
      setTotalInterest(secondTotal);

      const thirdTotal = cuotas
        .map(cuota => Number(cuota.multa))
        .reduce((acc, val) => acc + val, 0);
      setTotalFine(thirdTotal);

      setTotal(firstTotal + secondTotal + thirdTotal);
      // Calculo de totales, si hay cuotas seleccionadas... Calcula el total de todas las cuotas seleccionadas
    } else {
      const firstTotal = selectedCuotas
        .map(cuota => Number(cuota.monto_original))
        .reduce((acc, val) => acc + val, 0);
      setTotalAmount(firstTotal);

      const secondTotal = selectedCuotas
        .map(cuota => Number(cuota.intereses))
        .reduce((acc, val) => acc + val, 0);
      setTotalInterest(secondTotal);

      const thirdTotal = selectedCuotas
        .map(cuota => Number(cuota.multa))
        .reduce((acc, val) => acc + val, 0);
      setTotalFine(thirdTotal);

      setTotal(firstTotal + secondTotal + thirdTotal);
    }

  }, [cuotas, selectedCuotas]);

  function parseDate(dateString: string) {
    const [day, month, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day); // Meses son 0-indexados
  }
  const onSelectCuota = (cuota: ParsedCuota, index: number) => {
    const periodsCuot = cuotas.filter((cuot, i) => i <= index && cuot.intereses !== '0');
    const periodsSelCuot = selectedCuotas.filter((item, i) => item.id === cuota.id || i <= index);
    const isInCuotas = selectedCuotas.some(item => item.id === cuota.id);
    const itemsNoInterest = selectedCuotas.filter(item => item.intereses === '0');
    const concatedArray = periodsCuot.concat(itemsNoInterest);
    const concatedArray2 = periodsSelCuot.concat(itemsNoInterest);
    const fechaActual = new Date();
    //const mesActual = fechaActual.getMonth() + 1;
    //const anioActual = fechaActual.getFullYear();

    if (!isInCuotas) { //Sino esta tildado y se tilda devuelve false
      if (cuota.intereses === '0') {
        setSelectedCuotas([...selectedCuotas, cuota]);

        //Sacar todas las cuotas q TIENEN intereses
      } else {
        setSelectedCuotas(concatedArray);

        //Sacar todas las cuotas q NO TIENEN intereses
      }
    } else {
      if (cuota.intereses === '0') {
        setSelectedCuotas(selectedCuotas.filter(item => item.id !== cuota.id)); //Sacar todas las cuotas q TIENEN intereses
      } else { // Si la cuota es la única en la selección y se le hizo click vaciamos la selección
        if (periodsSelCuot.length == 1) {
          setSelectedCuotas([]);
          return;
        }
        setSelectedCuotas(concatedArray2);
        //Sacar todas las cuotas q NO TIENEN intereses
      }
    }

    fechaActual.setHours(0, 0, 0, 0);
    if (cuota.fecha_vto3) {
      if (parseDate(cuota.fecha_vto3) >= fechaActual) {
        setSelectedCuotas(cuotas.filter(item => item.id == cuota.id));
      }
    }
  };

  return (
    <TabPanel value={value} index={0}>
      <>
        {status === 'loading' || status === 'idle' ? (
          <CircularProgress size={20} />
        ) : (
          <>
            {cuotas.length >= 1 ? (
              <Box>
                {textVisible !== null && textVisible ? (
                  <>
                    <Typography variant="body1" mb={'1rem'}>
                      Todos los importes mostrados en la cuenta corriente tiene los intereses y DLNyF actualizados al día
                      de la fecha. Dependendiendo de la forma de pago elegida y la cantidad de cuotas seleccionadas pueden
                      aplicarse descuentos y/o otros beneficios.
                    </Typography>
                    <Typography variant="body1" mb={'1rem'}>
                      <strong>IMPORTANTE:</strong> En caso de cancelación total de
                      contado se aplicará un descuento del 25% sobre los intereses
                      generados.
                    </Typography></>
                ) : <></>}


                <Accordion defaultExpanded>
                  <AccordionSummary
                    sx={{
                      flexDirection: 'row-reverse',
                      backgroundColor: '#F5F8FA',
                      marginBottom: '10px',
                      paddingLeft: '20px',
                    }}
                    expandIcon={<ArrowIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography sx={{ paddingLeft: '.5rem' }}>
                      Liquidación Total
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetailsCustom>
                    {cuotas.length >= 1 ? (
                      <TableContainer component={Paper}>
                        <Table
                          sx={{ minWidth: 650 }}
                          size="small"
                          aria-label="simple table"
                        >
                          <TableHead sx={{ height: '2.5rem' }}>
                            <TableRow>
                              <TableCell align="center">
                                <TableTitle>Seleccionar</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>Año</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>Cuota</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>Monto</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>Intereses</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>DLNyF</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>Subtotal</TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableTitle>Estado de cuota</TableTitle>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {cuotas.map((cuota, i) => (
                              <TableRow
                                key={i}
                                sx={{
                                  '&:last-child td, &:last-child th': {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  <Checkbox
                                    checked={selectedCuotas?.some(item => item.id === cuota.id)}
                                    onClick={() => {
                                      onSelectCuota(cuota, i);
                                    }}
                                    icon={<UncheckedIcon />}
                                    checkedIcon={<CheckboxIcon />}
                                    {...label}
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <TableRegular>{cuota.anio}</TableRegular>
                                </TableCell>
                                <TableCell align="center">
                                  <TableRegular>{cuota.cuota}</TableRegular>
                                </TableCell>
                                <TableCell align="center">
                                  <TableBold>
                                    $ {Number(cuota.monto_original).toFixed(2)}
                                  </TableBold>
                                </TableCell>
                                <TableCell align="center">
                                  <TableBold>
                                    $ {Number(cuota.intereses).toFixed(2)}
                                  </TableBold>
                                </TableCell>
                                <TableCell align="center">
                                  <TableBold>$ {cuota.multa}</TableBold>
                                </TableCell>
                                <TableCell align="center">
                                  <TableBold>
                                    ${' '}
                                    {getTotales(
                                      cuota.monto_original,
                                      cuota.intereses,
                                      cuota.multa
                                    )}
                                  </TableBold>
                                </TableCell>
                                <TableCell align="center">
                                  {cuota.debito ? (
                                    <>
                                      {cuota.vigente === 'S' && (
                                        <Typography sx={{ color: '#4cd14b' }}>Vigente</Typography>
                                      )}
                                      {cuota.vigente === 'P' && (
                                        <Typography sx={{ color: '#eda34c' }}>En Procesamiento</Typography>
                                      )}
                                      {cuota.vigente === 'N' && (
                                        <Typography sx={{ color: '#ff3636' }}>Vencida</Typography>
                                      )}
                                    </>
                                  ) : (
                                    <TableRegular>
                                      <Typography sx={{ color: cuota.vigente == 'N' ? '#ff3636' : '#4cd14b' }}>{cuota.vigente == 'N' ? 'Vencida' : 'Vigente'}</Typography>
                                    </TableRegular>
                                  )}

                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow sx={{ height: '3rem' }}>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell align="center">
                                <TableTitle>
                                  TOTAL
                                </TableTitle>
                              </TableCell>
                              <TableCell align="center">
                                <TableBold>
                                  $ {totalAmount.toFixed(2)}
                                </TableBold>
                              </TableCell>
                              <TableCell align="center">
                                <TableBold>
                                  $ {totalInterest.toFixed(2)}
                                </TableBold>
                              </TableCell>
                              <TableCell align="center">
                                <TableBold>$ {totalFine.toFixed(2)}</TableBold>
                              </TableCell>
                              <TableCell align="center">
                                <TableBold>$ {total.toFixed(2)}</TableBold>
                              </TableCell>
                              <TableCell align="center">
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                        <Typography mt="1rem" mb="1rem" sx={{ textAlign: 'left' }}>
                          Por disposición normativa de la Municipalidad de San
                          Miguel, el pago de una cuota requiere que todas las
                          cuotas anteriores se encuentren regularizadas o lo
                          sean en el mismo acto
                        </Typography>
                        <Typography mt="1rem" mb="1rem" sx={{ textAlign: 'left' }}>
                          El <b>tiempo de acreditación</b> puede demorar hasta 15 días desde la fecha
                          de pago. Para los casos de Débito Automático la “fecha de pago”
                          coincide con el día previo a la fecha de vencimiento de la cuota.
                        </Typography>
                      </TableContainer>
                    ) : (
                      <CircularProgress size={20} />
                    )}
                  </AccordionDetailsCustom>
                </Accordion>
              </Box>
            ) : (
              <Typography>Estás al día!</Typography>
            )}
          </>
        )}
      </>
    </TabPanel>
  );
}
